/**
 * Simple bot detection based on user agent.
 */
import { Platform } from 'react-native';

export const isBot = (): boolean => {
  if (Platform.OS !== 'web') return false;

  const botPattern = /bot|googlebot|crawler|spider|robot|crawling/i;
  return botPattern.test(window.navigator.userAgent);
};
